import * as z from 'zod';

export const AuditChecklistFormSchema = z.object({
  type: z.literal('checklist'),

  isEveryRoomChecked: z.boolean(),
  isEveryFormFilled: z.boolean(),
  hasRooftopPhotos: z.boolean(),
  hasBuildingSidePhotos: z.boolean(),
  hasDoorsAndWindowsPhotos: z.boolean(),
  hasBASInterfacePhotos: z.boolean(),
  hasEnvelopeThermalImages: z.boolean(),
});

export type AuditChecklistForm = z.infer<typeof AuditChecklistFormSchema>;
